/* Hero floating metric cards. Swap for GET /api/metrics later. */

export const heroMetrics = [
  { id: "leads", label: "Leads", value: "+85%" },
  { id: "conversion", label: "Conversion", value: "+72%" },
  { id: "seo", label: "SEO Rankings", value: "+120%" },
  { id: "revenue", label: "Revenue Growth", value: "Up YoY" },
];
